import { makeStyles } from "@material-ui/core/styles";
import Spacer from "../../components/Spacer";
import MainContainer from "../../components/MainContainer";
import { headerDataRH } from "../../data/modules/hr-header";
import Title from "../../components/Title";
import { useState, useEffect, useContext } from "react";
import PlanningMissionService from "./../../services/PlanningMissionService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CvList from "./CvList";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import BanqueDeCvService from "../../services/BanqueCvService";
import { extraData } from "./ExtraData";
import { hasPrivilege } from "../../utils/privilege";
import { userDetailContext } from "../../App";
import { useLocation } from "react-router";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import useToast from "../../hooks/useToast";
import { FilterAltOutlined } from "@mui/icons-material";
import AppSplitButton from "../../components/reusable/AppSplitButton";
import { TYPE_NOTIFICATION } from "../../components/reusable/NotificationBull";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function Cvtable({ candidatIntern }) {
  const classes = useStyles();
  const titre = candidatIntern
    ? "Liste des CV internes"
    : "Liste des CV externes";
  const [direction, setDirection] = useState([]);
  const [service, setService] = useState([]);
  const [domaine_competence, setDomaineCompetence] = useState([]);
  const [sous_domaine_competence, setSousDomaineCompetence] = useState([]);
  const [active_offre_emplois, setActiveOffreEmplois] = useState([]);
  const contextData = useContext(userDetailContext);
  const location = useLocation();
  const { showToast, Toast } = useToast();
  const [loadingButton, setLoadingButton] = useState(false);
  const [isStagiaireOrSpontannee, setIsStagiaireOrSpontannee] = useState(false);
  const [filtre, setFiltre] = useState({
    direction_id: "",
    service_id: "",
    formation: "",
    diplome: "",
    refresh: 0,
    domaine_comp: "",
    sous_domaine: "",
    mot_cle: "",
    objet_candidature: "",
    isCVIntern: candidatIntern,
    isComplet: true,
  });
  const [excelRHExport, declenceRHExportToExcel] = useState(0);
  const [excelExpExport, declenceExpExportToExcel] = useState(0);

  const handleForbidenPageVisit = () => {
    if (
      location.pathname === "/cv_intern" &&
      !hasPrivilege(contextData.privileges, "CV Interne")
    ) {
      window.history.back();
    }
  };

  useEffect(() => {
    setFiltre({ ...filtre, isCVIntern: location.pathname.split("/")[2] === "cv_intern" });
    handleForbidenPageVisit();
  }, [location.pathname]);

  useEffect(() => {
    setIsStagiaireOrSpontannee(
      ["/cv_stagiaire", "/cv_spontannee"].includes(location.pathname)
    );
    if (location.pathname === "/cv_stagiaire") {
      setFiltre({
        ...filtre,
        objet_candidature: { id_type: "18" },
        refresh: filtre.refresh + 1,
      });
    } else if (location.pathname === "/cv_spontannee") {
      setFiltre({
        ...filtre,
        objet_candidature: { id_type: "15" },
        refresh: filtre.refresh + 1,
      });
    } else {
      setFiltre({
        ...filtre,
        objet_candidature: "",
        // refresh: filtre.refresh + 1,
      });
    }
  }, [location.pathname]);

  const handleRHExportToexcelEvent = () => {
    showToast(
      TYPE_NOTIFICATION.INFO,
      "Préparation de l'exportation des données..."
    );
    declenceRHExportToExcel(excelRHExport + 1);
  };

  //Export excle de toutes les experiences
  const handleExpExportToexcelEvent = () => {
    showToast(
      TYPE_NOTIFICATION.INFO,
      "Préparation de l'exportation des données..."
    );
    declenceExpExportToExcel(excelExpExport + 1);
  };

  function handleChangeDirection(event, value) {
    try {
      PlanningMissionService.getService(value.direction_id).then((result) => {
        if (result && result.data) {
          setService(result.data);
          setFiltre({ ...filtre, direction_id: value });
        }
      });
    } catch (err) {
      setService([]);
      setFiltre({ ...filtre, direction_id: 0 });
    }
  }

  function handleChangeDomaineDeCompetence(event, value) {
    try {
      BanqueDeCvService.ShowSousdomaine(value.id_domaine).then((result) => {
        if (result && result.data) {
          setSousDomaineCompetence(result.data);
          setFiltre({ ...filtre, domaine_comp: value });
        }
      });
    } catch (err) {
      setSousDomaineCompetence([]);
      setFiltre({ ...filtre, domaine_comp: "" });
    }
  }

  function handleChangeService(event, value) {
    let srv_id = value !== null ? value : 0;
    setFiltre({ ...filtre, service_id: srv_id });
  }

  function handleChangeDiplome(event, value) {
    let dpl = value !== null ? value : "";
    setFiltre({ ...filtre, diplome: dpl });
  }

  function handleChangeSousDomaine(event, value) {
    let sd = value !== null ? value : "";
    setFiltre({ ...filtre, sous_domaine: sd });
  }

  function handleObjetCandatureChange(event, value) {
    let sd = value !== null ? value : "";
    setFiltre({ ...filtre, objet_candidature: sd });
  }

  function handleChangeFormation(event, value) {
    let srv_id = value !== null ? value : 0;
    setFiltre({ ...filtre, formation: srv_id });
  }

  const handleActionRefresh = () => {
    var newrefreshe = filtre.refresh + 1;
    setFiltre({ ...filtre, refresh: newrefreshe });
  };

  const handleFilterActionUpdate = (event) => {
    const { name, value } = event.target;
    setFiltre({ ...filtre, [name]: value });
  };

  useEffect(() => {
    PlanningMissionService.getDirection().then((result) => {
      if (result && result.data) {
        setDirection(result.data);
      }
    });

    BanqueDeCvService.showDomaineCompetence().then((res) => {
      if (res) {
        //setDomaineCompetence(changeAttributeName(res.data,'name','label'));
        setDomaineCompetence(res.data);
      }
    });
    BanqueDeCvService.showAllOpenPostedPosition().then((res) => {
      if (res) {
        setActiveOffreEmplois(res.data);
      }
    });
  }, []);

  return (
    <MainContainer {...headerDataRH}>
      <Spacer y={2} />
      <Toast />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper} variant="outlined">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 20,
              }}
            >
              <Grid display={"flex"} flexDirection={"row"}>
                <Grid
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-around"}
                >
                  <Tooltip title={"Actualiser les données"}>
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={handleActionRefresh}
                      startIcon={<FilterAltOutlined />}
                    >
                      <Typography> Filtrer</Typography>
                    </Button>
                  </Tooltip>
                  <Tooltip title={"Exporter les données en fichier Excel"}>
                    <AppSplitButton
                      loading={loadingButton}
                      sx={{ marginLeft: 1 }}
                      size="small"
                      options={[
                        {
                          text:"Détails export",
                          action: () => handleRHExportToexcelEvent(),
                          icon: <GetAppOutlinedIcon />,
                        },
                        {
                          text: "RH Export",
                          action: () => handleExpExportToexcelEvent(),
                          icon: <GetAppOutlinedIcon />,
                        },
                      ]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid flexGrow={1} textAlign={"center"}>
                <Title>{titre}</Title>
              </Grid>
              <Grid>
                <FormControlLabel
                  sx={{
                    display: /* filtre.isCVIntern ? */ "none" /* : "flex" */,
                  }}
                  control={
                    <Checkbox
                      checked={filtre.isComplet}
                      onChange={(evt) =>
                        setFiltre({ ...filtre, isComplet: evt.target.checked })
                      }
                      name="gilad"
                    />
                  }
                  label="Dossier complet"
                />
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<ExitToAppOutlinedIcon />}
                  onClick={(e) => {
                    window.open(
                      process.env.REACT_APP_EXTERNAL_ADMIN_LINK +
                        `?ref=${localStorage.getItem("ACCESS_TOKEN")}`,
                      "_blank"
                    );
                  }}
                  style={{
                    fontWeight: 600,
                  }}
                >
                  Candidature Externes
                </Button>
              </Grid>
            </div>
            <Grid container spacing={3}>
              <Grid
                item
                xs={4}
                style={{ display: candidatIntern ? "" : "none" }}
              >
                <Autocomplete
                  onChange={handleChangeDirection}
                  options={direction}
                  getOptionLabel={(option) =>
                    option.name + " (" + option.code + ")"
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Direction"
                      name="direction"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={4}
                style={{ display: candidatIntern ? "" : "none" }}
              >
                <Autocomplete
                  onChange={handleChangeService}
                  options={service}
                  getOptionLabel={(option) =>
                    option.name + " (" + option.code + ")"
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Service"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                      name="service"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  onChange={handleChangeFormation}
                  options={extraData.formation}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="formation"
                      fullWidth
                      label="Formation"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  onChange={handleChangeDiplome}
                  options={extraData.diplome}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="diplome"
                      fullWidth
                      label="Diplôme"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  onChange={handleChangeDomaineDeCompetence}
                  options={domaine_competence}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Domaine de competence"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                      name="domaine_comp"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={4}>
                <Autocomplete
                  onChange={handleChangeSousDomaine}
                  options={sous_domaine_competence || null}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Sous domaine de competence"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                      name="sous_domaine"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display:
                    candidatIntern || isStagiaireOrSpontannee ? "none" : "",
                }}
              >
                <Autocomplete
                  onChange={handleObjetCandatureChange}
                  options={active_offre_emplois || null}
                  getOptionLabel={(option) => option.libelle_type}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label="Objet candidature"
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: "search" }}
                      onChange={handleFilterActionUpdate}
                      name="objet_candidature"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={4}
                style={{ display: !candidatIntern ? "" : "none" }}
              >
                <TextField
                  fullWidth
                  id="outlined-basic"
                  size="small"
                  label="Mot clé de description"
                  variant="outlined"
                  name="mot_cle"
                  onChange={handleFilterActionUpdate}
                />
              </Grid>
            </Grid>
            <Grid>
              <CvList
                excel_export={excelRHExport}
                exp_export={excelExpExport}
                filter={filtre}
              />
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </MainContainer>
  );
}
